import { DataIdConverterFactory, DataIdArrayConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { RefModeCalcul } from './ref-mode-calcul.model';
import { RefQuantiteFacture } from './ref-quantite-facture.model';
import { RefTva } from './ref-tva.model';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Campagne } from '../../declaration/models/campagne.model';

export class ModeleArticle {
    static jsonMap = {
        id: { key: 'id', optional: true },
        libelle: { key: 'libelle' },
        refModeCalcul: { key: 'idRefModeCalcul', converter: new (DataIdConverterFactory.build(RefModeCalcul, 'refModeCalculList'))() },
        refQuantiteFacture: {
            key: 'idRefQuantiteFacture',
            converter: new (DataIdConverterFactory.build(RefQuantiteFacture, 'refQuantiteFactureList'))()
        },
        refTva: { key: 'idRefTva', converter: new (DataIdConverterFactory.build(RefTva, 'refTvaList'))() },
        cahiers: { key: 'idCahiers', converter: new (DataIdArrayConverterFactory.build(Cahier, 'cahiers'))() },
        prixUnitaire: { key: 'prixUnitaire' },
        quantiteMinimum: { key: 'quantiteMinimum' },
        campagnes: { key: 'campagnes', converter: new (DataIdArrayConverterFactory.build(Campagne, 'campagnes'))(), optional: true }
    };

    id: number;
    libelle: string;
    refModeCalcul: RefModeCalcul;
    refQuantiteFacture: RefQuantiteFacture;
    refTva: RefTva;
    cahiers: Cahier[] = undefined;
    prixUnitaire: number;
    quantiteMinimum: number;
    campagnes: Campagne[] = undefined;
}
